<div class="container-fluid main-card">
    <div class="row">
        <div class="col-lg-7 col-12">
            <h1>
                Dashboard API
                <span *ngIf="user.api_plan != ''">Plan {{ getPlanLabel() }}</span>
            </h1>
        </div>
        <div class="col-lg-5 col-12 text-end mt-lg-3 optionMenu">
            <div class="d-inline-block mb-2 me-2">
                <a class="btn btn-outline" href="https://api.lybox.fr/api/doc" target="_blank">
                    <i class="fa fa-book"></i>
                    <span>Documentation</span>
                </a>
            </div>
            <div class="d-inline-block mb-2">
                <a class="btn btn-outline" routerLink="/app/user/plan-api">
                    <i class="fa fa-plus-circle"></i>
                    <span>Crédits supplémentaires</span>
                </a>
            </div>
        </div>

        <!-- Crédits KPI -->
        <div class="col-12">
            <div class="row kpi">
                <div class="col-6 col-lg-3">
                    <div class="card kpi-blue">
                        <div class="card-body kpi-card">
                            <h5 class="card-title">Crédits mensuels</h5>
                            <p class="card-value">{{ creditData.plan_credit | number }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-3">
                    <div class="card kpi-orange">
                        <div class="card-body kpi-card">
                            <h5 class="card-title">Crédits supplémentaires</h5>
                            <p class="card-value">{{ creditData.ayg_credit | number }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-3">
                    <div class="card kpi-green">
                        <div class="card-body kpi-card">
                            <h5 class="card-title">Total disponible</h5>
                            <p class="card-value">{{ creditData.plan_credit + creditData.ayg_credit | number }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-3" *ngIf="getExpirationDate() != ''">
                    <div class="card kpi-purple">
                        <div class="card-body kpi-card">
                            <h5 class="card-title">{{ user.api_plan != '' ? 'Renouvellement' : 'Expiration' }}</h5>
                            <p class="card-value">{{ getExpirationDate() }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Token API -->
        <div class="col-12">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Token API</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div *ngIf="tokens.length > 0">
                        <div class="token-item" *ngFor="let token of tokens">
                            <code class="token-value">{{ token }}</code>
                            <a class="btn btn-sm btn-outline-primary" (click)="copyToken(token)">
                                {{ copiedToken ? 'Copié !' : 'Copier' }}
                            </a>
                        </div>
                    </div>
                    <p class="mb-0 fs-4" *ngIf="tokens.length == 0">
                        Aucun token API généré. <a href="mailto:contact@lybox.fr">Contactez-nous</a> pour obtenir votre token.
                    </p>
                </div>
            </div>
        </div>

        <!-- Graph -->
        <div class="col-12">
            <div class="card block isMinimizable">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <div class="card-title mb-0">
                        <i class="fa fa-angle-up"></i>
                        <h2>Consommation API</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="card-text row">
                        <div echarts [options]="chartOptions" [merge]="chartData" class="chart" (chartInit)="onChartInit($event)"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Logs -->
        <div class="col-12">
            <div class="card block isMinimizable minimize logs-block">
                <div class="card-header">
                    <div class="card-title">
                        <i class="fa fa-angle-up"></i>
                        <h2>Derniers appels API</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="text-center py-4" *ngIf="loadingLogs">
                        <mat-spinner diameter="30" class="mx-auto"></mat-spinner>
                    </div>

                    <div class="table-responsive" *ngIf="!loadingLogs && logs.length > 0">
                        <table class="table table-striped table-hover logs-table">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Endpoint</th>
                                <th>Paramètres</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Crédits</th>
                                <th class="text-center">Résultats</th>
                                <th class="text-end">Temps</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let log of logs">
                                <td class="log-date">{{ formatDate(log.created_at) }}<br/><small>{{ log.created_at | slice:11:19 }}</small></td>
                                <td><code>{{ log.url }}</code></td>
                                <td class="log-params">
                                    <small *ngIf="log.query_params">{{ log.query_params }}</small>
                                </td>
                                <td class="text-center">
                                    <span class="status-badge" [ngClass]="getStatusClass(log.status_code)">{{ log.status_code }}</span>
                                </td>
                                <td class="text-center"><b>{{ log.cost }}</b></td>
                                <td class="text-center">{{ log.nb_results }}</td>
                                <td class="text-end"><small>{{ log.time | number:'1.2-2' }}s</small></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="text-center py-3" *ngIf="!loadingLogs && logs.length == 0">
                        <p class="mb-0 fs-4">Aucun appel API enregistré.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
